import styled, { css } from 'styled-components';

import { Flex } from '../../../../Flex';

export const VerticalStepper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 155px;
  max-width: 155px;
  position: absolute;
  transition: top ease-out 0.2s;
  @media (max-width: 1330px) {
    display: none;
  }
  left: 0;
  top: 128px;

  ${({ theme }) => css`
    padding: ${theme.spacing(3)};
    background-color: ${theme.colors.whiteAlpha40};
    z-index: ${theme.zIndex.stickyAfterFooter};
  `}
`;
export const Step = styled(Flex)<{ $isActive: boolean; $afterStep: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  position: relative;
  height: 100%;
  &:last-child {
    .line {
      display: none;
    }
  }
  ${({ theme }) => css`
    color: ${theme.colors.navyBlueSub1};
  `}
  ${({ $isActive, theme }) =>
    $isActive &&
    css`
      .step-label {
        text-decoration: underline;
        text-decoration-color: ${theme.colors.navyBlueSub1};
        text-decoration-thickness: 1px;
      }
      .step-content {
        border: 3px solid ${theme.colors.navyBlueSub1};
        background-color: ${theme.colors.white};
      }
    `}
    ${({ theme, $afterStep }) =>
    $afterStep &&
    css`
      .step-content {
        border: 3px solid ${theme.colors.navyBlueSub1};
        background-color: ${theme.colors.white};
      }
      .line {
        border-right: 1px solid ${theme.colors.navyBlueSub1};
      }
    `}
`;
export const StepLabel = styled.div`
  cursor: pointer;
  font-weight: bold;
  width: 80px;
  line-height: 22px;
  text-align: right;
  ${({ theme }) => css`
    color: ${theme.colors.navyBlueSub1};
    margin-bottom: 12px;
    &:hover {
      text-decoration: underline;
      text-decoration-color: ${theme.colors.navyBlueSub1};
      text-decoration-thickness: 1px;
    }
  `}
`;
export const StepContent = styled.div`
  border-radius: 50%;
  width: 15px;
  height: 15px;
  min-height: 15px;
  position: relative;
  z-index: 10;
  ${({ theme }) => css`
    border: 3px solid ${theme.colors.white};
    background-color: ${theme.colors.mediumGrey};
    margin-left: ${theme.spacing(1.5)};
    &::after {
      height: 100%;
      width: 1px;
      backgr>ound: ${theme.colors.mediumGrey};
    }
  `}
`;
export const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-items: flex-end;
`;
export const StepLine = styled.div`
  margin-right: 7px;
  min-height: 50px;
  height: calc(100% - 15px);
  ${({ theme }) => css`
    border-right: 1px solid ${theme.colors.mediumGrey};
  `}
`;
